import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import UserEdit from "../../../../../components/admin/users/edit/UserEdit";

const AdminUserEdit = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.user.admin.edit")}>
      <UserEdit />
    </PageWrapper>
  );
};

export default AdminUserEdit;
